import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 清空 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["innerHTML"]

import { onBeforeMount, ref, toRaw, watch } from 'vue'
import SearchBar from '@/components/common/SearchBar.vue'
import {
  TableTabMap,
  TableTabList,
  CoursewareType,
  CoursewareTypeOpts,
  BookTypeMap
} from '../config'
import WaitTable from './components/WaitTable.vue'
import PassTable from './components/PassTable.vue'
import FailTable from './components/FailTable.vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'
import { PermissionMap } from '@/utils/auth'
import { usePageTableContext } from '@evideo/frontend-utils'
import pageTableContextMap from '@/utils/pageTableContextMap'
// import { getCoursewareInfo } from '@/services/courseware'
import { getTeacherCourseware } from '@/views/mine-coursewares/service'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const queryParams = ref<string | undefined>(undefined)

const formData = ref<any>({
  type: undefined,
  teacher_name: undefined,
  teacher_school_name: undefined,
  official_book_id: undefined,
  official_book_section_id: undefined
})

const waitTableRef = ref<any>()
const passTableRef = ref<any>()
const failTableRef = ref<any>()

// 当前选择的tab类型
const currentTableType = ref<any>(TableTabMap.WAIT)

// 是否预览
const previewVisible = ref<boolean>(false)

// 当前预览的数据
const currentPreview = ref<any>()

// 当前预览教案富文本内容
const planContent = ref<any>()

// 选择了的教材
const showBookName = ref<string>('')

// 是否选择教材章节
const selectBookVisible = ref<boolean>(false)

const contextPage = ref<number>(1)

const { getContextInfo, saveContextInfo, deleteContextInfo } = usePageTableContext()

const getCurrentTableRef = () => {
  let currentTableRef: any
  switch (currentTableType.value) {
  case TableTabMap.WAIT:
    currentTableRef = waitTableRef
    break
  case TableTabMap.PASS:
    currentTableRef = passTableRef
    break
  case TableTabMap.FAIL:
    currentTableRef = failTableRef
    break
  default:
    currentTableRef = waitTableRef
  }
  return currentTableRef
}

// 保存用户当前的检索条件上下文
const handleSaveContextInfo = () => {
  const page = getCurrentTableRef().value.getCurrentPage()
  const pageContext = {
    formData: toRaw(formData.value),
    queryParams: queryParams.value,
    currentPage: page,
    currentTableType: toRaw(currentTableType.value),
    showBookName: toRaw(showBookName.value)
  }
  console.log('save page context ====> ', pageContext)
  saveContextInfo(pageTableContextMap.PLATFORM_COURSEWARE_AUDIT, pageContext)
}

// 从保存的上下文中获取列表筛选条件信息
const handleGetContext = () => {
  const context = getContextInfo(pageTableContextMap.PLATFORM_COURSEWARE_AUDIT)
  console.log('get page context ===> ', context)
  const {
    formData: fData,
    queryParams: qParams,
    currentPage,
    currentTableType: cTableType,
    showBookName: sbName
  } = context
  // 将上下文中的数值注入到搜索参数中
  if (fData) { formData.value = fData }
  if (qParams) { queryParams.value = qParams }
  if (cTableType) { currentTableType.value = cTableType }
  if (currentPage && currentPage > 1) {
    // 修改当前对应列表的搜索页
    contextPage.value = currentPage
  }
  if (sbName) { showBookName.value = sbName }
  deleteContextInfo(pageTableContextMap.PLATFORM_COURSEWARE_AUDIT)
}

// 搜索
const handleSearch = () => {
  let currentTableRef: any
  switch (currentTableType.value) {
  case TableTabMap.WAIT:
    currentTableRef = waitTableRef
    break
  case TableTabMap.PASS:
    currentTableRef = passTableRef
    break
  case TableTabMap.FAIL:
    currentTableRef = failTableRef
    break
  default:
    currentTableRef = waitTableRef
  }
  if (currentTableRef.value) {
    currentTableRef.value.handleSearch()
  }
}

// 选择教材弹窗
const handleShowSelectModal = () => {
  selectBookVisible.value = true
}

// 重置教材选择
const handleResetSelectBook = () => {
  showBookName.value = ''
  formData.value.official_book_id = undefined
  formData.value.official_book_section_id = undefined
}

// 重置搜索条件
const handleResetForm = () => {
  formData.value = {
    type: undefined,
    teacher_name: undefined,
    teacher_school_name: undefined,
    official_book_id: undefined,
    official_book_section_id: undefined
  }
  queryParams.value = undefined
  handleResetSelectBook()
  handleSearch()
}

// 预览
const handlePreview = async (record: any) => {
  if ([CoursewareType.PPT, CoursewareType.SHEET_SONG, CoursewareType.QGROUP].includes(record.type)) {
    console.log('PPT preview')
    const recordId = record.id
    // 跳转前先保存搜索选项上下文信息
    handleSaveContextInfo()
    router.push(`/resource/audit-management/official/${recordId}/preview`)
  } else if (record.type === CoursewareType.PLAN) {
    previewVisible.value = true
    currentPreview.value = {
      type: record.type,
      name: record.name
    }
    try {
      const data = await getTeacherCourseware(record.courseware_id)
      planContent.value = data.plan_content
    } catch (e) {
      console.log(e)
    }
  } else if (record.type === CoursewareType.FLASH) {
    message.info('SWF课件类型暂不支持在线预览')
  } else {
    currentPreview.value = {
      type: record.type,
      name: record.name,
      url: record.url
    }
    previewVisible.value = true
  }
}

// 取消预览
const handlePreviewCancel = () => {
  currentPreview.value = undefined
  previewVisible.value = false
}

// 选择教材完毕
const handleSelectBookOk = info => {
  selectBookVisible.value = false
  const { values, labels } = info
  if (values && values.length > 0) {
    if (values[0]) {
      formData.value.official_book_id = values[0]
    }
    if (values[1]) {
      formData.value.official_book_section_id = values[1]
    }
  } else {
    formData.value.official_book_id = undefined
    formData.value.official_book_section_id = undefined
  }
  if (labels && labels.length > 0) {
    showBookName.value = labels.join('/')
  } else {
    showBookName.value = ''
  }
}

onBeforeMount(() => {
  handleGetContext()
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _directive_nopreventright = _resolveDirective("nopreventright")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "head_body" }, {
        default: _withCtx(() => [
          _createVNode(SearchBar, {
            value: queryParams.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (queryParams.value = $event)),
            onSearch: handleSearch,
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 8, ["value", "onKeyup"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "content_body" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                layout: "inline",
                onKeyup: _withKeys(handleSearch, ["enter"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    style: {"width":"100%"},
                    gutter: [16, 16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "课件类型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: _unref(CoursewareTypeOpts),
                                value: formData.value.type,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (formData.value.type = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "作者" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formData.value.teacher_name,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (formData.value.teacher_name = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属学校" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formData.value.teacher_school_name,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (formData.value.teacher_school_name = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属教材章节" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: handleShowSelectModal
                              }, [
                                (showBookName.value.length > 15)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      title: showBookName.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(showBookName.value.slice(0, 15)) + "... ", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["title"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(showBookName.value || "请选择教材章节"), 1))
                              ]),
                              _withDirectives(_createVNode(_component_a_button, {
                                style: {"margin-left":"10px"},
                                size: "small",
                                onClick: handleResetSelectBook
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, showBookName.value.length > 0]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            style: {"margin-right":"15px"},
                            onClick: handleResetForm
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: handleSearch
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, { style: {"margin-top":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: currentTableType.value,
                "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => (currentTableType.value = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TableTabList), (tab) => {
                    return (_openBlock(), _createBlock(_component_a_tab_pane, {
                      key: tab.value,
                      tab: tab.label
                    }, null, 8, ["tab"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["activeKey"]),
              _createElementVNode("div", null, [
                (currentTableType.value === _unref(TableTabMap).WAIT)
                  ? (_openBlock(), _createBlock(WaitTable, {
                      key: 0,
                      ref: (_value, _refs) => {
                        _refs['waitTableRef'] = _value
                        waitTableRef.value = _value
                      },
                      formData: formData.value,
                      searchBarData: queryParams.value,
                      onOnPreview: handlePreview,
                      contextPage: contextPage.value,
                      "onUpdate:contextPage": _cache[5] || (_cache[5] = ($event: any) => (contextPage.value = $event))
                    }, null, 8, ["formData", "searchBarData", "contextPage"]))
                  : _createCommentVNode("", true),
                (currentTableType.value === _unref(TableTabMap).PASS)
                  ? (_openBlock(), _createBlock(PassTable, {
                      key: 1,
                      ref: (_value, _refs) => {
                        _refs['passTableRef'] = _value
                        passTableRef.value = _value
                      },
                      formData: formData.value,
                      searchBarData: queryParams.value,
                      onOnPreview: handlePreview,
                      contextPage: contextPage.value,
                      "onUpdate:contextPage": _cache[6] || (_cache[6] = ($event: any) => (contextPage.value = $event))
                    }, null, 8, ["formData", "searchBarData", "contextPage"]))
                  : _createCommentVNode("", true),
                (currentTableType.value === _unref(TableTabMap).FAIL)
                  ? (_openBlock(), _createBlock(FailTable, {
                      key: 2,
                      ref: (_value, _refs) => {
                        _refs['failTableRef'] = _value
                        failTableRef.value = _value
                      },
                      formData: formData.value,
                      searchBarData: queryParams.value,
                      onOnPreview: handlePreview,
                      contextPage: contextPage.value,
                      "onUpdate:contextPage": _cache[7] || (_cache[7] = ($event: any) => (contextPage.value = $event))
                    }, null, 8, ["formData", "searchBarData", "contextPage"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(SelectBookModal, {
            visible: selectBookVisible.value,
            "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (selectBookVisible.value = $event)),
            onOk: handleSelectBookOk,
            type: _unref(BookTypeMap).OFFICIAL
          }, null, 8, ["visible", "type"]),
          (previewVisible.value)
            ? (_openBlock(), _createBlock(_component_a_modal, {
                key: 0,
                visible: previewVisible.value,
                onCancel: handlePreviewCancel,
                destroyOnClose: "",
                maskClosable: false,
                width: currentPreview.value?.type === _unref(CoursewareType).AUDIO ? 500 : 1000,
                footer: null,
                style: _normalizeStyle(
          currentPreview.value?.type === _unref(CoursewareType).AUDIO ? {} : { top: '20px' }
        )
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, [
                    (currentPreview.value.name?.length > 15)
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 0,
                          title: currentPreview.value.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 预览课件: " + _toDisplayString(currentPreview.value.name.slice(0, 14)) + "... ", 1)
                          ]),
                          _: 1
                        }, 8, ["title"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, "预览课件: " + _toDisplayString(currentPreview.value.name), 1))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (currentPreview.value?.type === _unref(CoursewareType).IMAGE)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"max-width":"100%","max-height":"80vh"},
                          src: currentPreview.value?.url
                        }, null, 8, _hoisted_7)), [
                          [_directive_nopreventright]
                        ])
                      : _createCommentVNode("", true),
                    (currentPreview.value?.type === _unref(CoursewareType).VIDEO)
                      ? _withDirectives((_openBlock(), _createElementBlock("video", {
                          key: 1,
                          style: {"width":"100%"},
                          controls: "",
                          src: currentPreview.value?.url,
                          controlslist: "nodownload"
                        }, null, 8, _hoisted_8)), [
                          [_directive_nopreventright]
                        ])
                      : _createCommentVNode("", true),
                    (currentPreview.value?.type === _unref(CoursewareType).AUDIO)
                      ? _withDirectives((_openBlock(), _createElementBlock("audio", {
                          key: 2,
                          style: {"width":"100%"},
                          controls: "",
                          src: currentPreview.value?.url,
                          controlslist: "nodownload"
                        }, null, 8, _hoisted_9)), [
                          [_directive_nopreventright]
                        ])
                      : _createCommentVNode("", true),
                    (currentPreview.value?.type === _unref(CoursewareType).SPEAK)
                      ? _withDirectives((_openBlock(), _createElementBlock("video", {
                          key: 3,
                          style: {"width":"100%"},
                          controls: "",
                          src: currentPreview.value?.url,
                          controlslist: "nodownload"
                        }, null, 8, _hoisted_10)), [
                          [_directive_nopreventright]
                        ])
                      : _createCommentVNode("", true),
                    (currentPreview.value?.type === _unref(CoursewareType).PLAN)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: "planContent",
                          style: {"width":"100%"},
                          controls: "",
                          controlslist: "nodownload",
                          innerHTML: planContent.value
                        }, null, 8, _hoisted_11)), [
                          [_directive_nopreventright]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["visible", "width", "style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512)), [
    [_directive_permission, _unref(PermissionMap).AUDIT_MANAGEMENT_PLATFORM_LIST]
  ])
}
}

})